import { createFileRoute, Link } from '@tanstack/react-router';
import { Header, Footer } from '@/components/marketing';
import { Badge } from '@/components/ui/badge';

export const Route = createFileRoute('/sitemap')({
  component: SitemapPage,
});

const siteLinks = {
  main: [
    { href: '/', label: 'Home' },
    { href: '/about', label: 'About' },
    { href: '/platform', label: 'Platform' },
    { href: '/pricing', label: 'Pricing' },
    { href: '/enterprise', label: 'Enterprise' },
    { href: '/contact', label: 'Contact' },
    { href: '/demo', label: 'Request Demo' },
  ],
  products: [
    { href: '/products', label: 'All Products' },
    { href: '/products/aicodeforge', label: 'AI Code Forge' },
    { href: '/products/codespringforge', label: 'CodeSpring Forge' },
    { href: '/products/sdd-forge', label: 'SDD Forge' },
  ],
  resources: [
    { href: '/docs', label: 'Documentation' },
    { href: '/docs/api', label: 'API Reference' },
    { href: '/blog', label: 'Blog' },
    { href: '/changelog', label: 'Changelog' },
    { href: '/community', label: 'Community' },
    { href: '/roadmap', label: 'Product Roadmap' },
  ],
  company: [
    { href: '/careers', label: 'Careers' },
    { href: '/affiliates', label: 'Affiliate Program' },
    { href: '/support', label: 'Support Center' },
  ],
  legal: [
    { href: '/privacy', label: 'Privacy Policy' },
    { href: '/terms', label: 'Terms of Service' },
    { href: '/security', label: 'Security' },
  ],
  account: [
    { href: '/login', label: 'Sign In' },
    { href: '/register', label: 'Create Account' },
    { href: '/forgot-password', label: 'Reset Password' },
  ],
};

function SitemapPage() {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1 pt-24 pb-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
          <div className="text-center mb-12">
            <Badge variant="secondary" className="mb-4">Navigation</Badge>
            <h1 className="text-4xl font-bold tracking-tight sm:text-5xl mb-4">Sitemap</h1>
            <p className="text-muted-foreground text-lg">
              Find your way around ForgeNetwork
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <SitemapSection title="Main Pages" links={siteLinks.main} />
            <SitemapSection title="Products" links={siteLinks.products} />
            <SitemapSection title="Resources" links={siteLinks.resources} />
            <SitemapSection title="Company" links={siteLinks.company} />
            <SitemapSection title="Legal" links={siteLinks.legal} />
            <SitemapSection title="Account" links={siteLinks.account} />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

function SitemapSection({ title, links }: { title: string; links: { href: string; label: string }[] }) {
  return (
    <div className="bg-card rounded-lg border p-6">
      <h2 className="text-xl font-semibold mb-4">{title}</h2>
      <ul className="space-y-2">
        {links.map((link) => (
          <li key={link.href}>
            <Link
              to={link.href}
              className="text-muted-foreground hover:text-primary transition-colors"
            >
              {link.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
